import React, { useState } from "react";
import ReactDiffViewer from "react-diff-viewer-continued";

const DIFF_STYLES = {
	variables: {
		light: {
			diffViewerBackground: "#ffffff",
			diffViewerColor: "#24292f",
			diffViewerTitleBackground: "#f6f8fa",
			diffViewerTitleColor: "#57606a",
			diffViewerTitleBorderColor: "#d0d7de",
			addedBackground: "#e6ffec",
			addedColor: "#116329",
			removedBackground: "#ffebe9",
			removedColor: "#82071e",
			gutterBackground: "#f6f8fa",
			gutterColor: "#57606a",
			addedGutterBackground: "#ccffd8",
			removedGutterBackground: "#ffd7d5",
			wordAddedBackground: "#abf2bc",
			wordRemovedBackground: "#ffc1ba",
			codeFoldBackground: "#f6f8fa",
			codeFoldGutterBackground: "#f6f8fa",
		},
	},
	contentText: {
		fontSize: "12px",
		fontFamily:
			"ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Courier New', monospace",
	},
	lineContent: {
		fontSize: "12px",
	},
};

export default function WritingPreviewRawDiff({ originalMd, patchedMd }) {
	const [isOpen, setIsOpen] = useState(false);
	const [splitView, setSplitView] = useState(true);

	if (!originalMd || !patchedMd) return null;

	return (
		<div className="writing-preview__raw-diff">
			<button
				type="button"
				className="writing-preview__raw-diff-toggle"
				onClick={() => setIsOpen((prev) => !prev)}
				aria-expanded={isOpen}
			>
				<i className={`fas fa-chevron-${isOpen ? "down" : "right"} me-2`} />
				Raw markdown diff
			</button>
			{isOpen && (
				<>
					<div className="writing-preview__raw-diff-toolbar">
						<div className="btn-group btn-group-sm" role="group" aria-label="Diff view mode">
							<button
								type="button"
								className={`btn ${splitView ? "btn-primary" : "btn-outline-secondary"}`}
								onClick={() => setSplitView(true)}
								aria-pressed={splitView}
							>
								Split view
							</button>
							<button
								type="button"
								className={`btn ${!splitView ? "btn-primary" : "btn-outline-secondary"}`}
								onClick={() => setSplitView(false)}
								aria-pressed={!splitView}
							>
								Unified view
							</button>
						</div>
					</div>
					<div className="writing-preview__raw-diff-viewer">
						<ReactDiffViewer
							oldValue={originalMd}
							newValue={patchedMd}
							splitView={splitView}
							useDarkTheme={false}
							leftTitle={splitView ? "Before" : undefined}
  rightTitle={splitView ? "After" : ""}
							showDiffOnly={false}
							hideLineNumbers={false}
							styles={DIFF_STYLES}
						/>
					</div>
				</>
			)}
		</div>
	);
}
